import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { brandAssetsService, type BrandAssets } from "../api/brandAssetsService";

const QK = ["brand-assets", "me"] as const;

export function useBrandAssets() {
  return useQuery({
    queryKey: QK,
    queryFn: brandAssetsService.getMy,
    staleTime: 60_000,
  });
}

export function useUpdateBrandAssets() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: BrandAssets) => brandAssetsService.replaceMy(dto),
    onSuccess: (saved) => {
      qc.setQueryData(QK, saved);
    },
  });
}
